export interface HumanChatSendRetry {
  text: string;
  commandId: string;
  epoch: number;
  conversationId: string;
}

export function isHumanChatSendRetry(value: unknown): value is HumanChatSendRetry {
  const retry = value as HumanChatSendRetry | null;
  return !!retry && typeof retry.text === 'string' && retry.text.length > 0 && retry.text.length <= 8000
    && typeof retry.commandId === 'string' && retry.commandId.length > 0 && retry.commandId.length <= 200
    && typeof retry.conversationId === 'string' && retry.conversationId.length > 0 && retry.conversationId.length <= 200
    && Number.isSafeInteger(retry.epoch) && retry.epoch >= 0;
}